// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format5 } from '../../constants';

import { format2 } from '../../constants';

/** Bulgaria */
const BG: PhoneNumberData = [359, 'BG', 8, format5, 9, format2];

export default BG;
